module.exports = __webpack_public_path__ + "static/media/bodegas.f49c38b5.png";